<template>

	<div class="app-principal">	
		<div class="app-topo">
            <top-bar title="Mapa de Produção" exibeVoltar="true" historyback="false" 
                @navigate="navigate" navigateto="mapaproducao"/>
        </div>
		<div class="app-centro-sem-rodape">
            <h3>Selecione o período:</h3>
            <div class="div-linha">
                <div class="label">Data início</div>
                <div class="campo">
                    <input type="date" class="input-data" v-model="datainicio"/>
                </div>
            </div>
            <div class="div-linha">
                <div class="label">Data fim</div>
                <div class="campo">
                    <input type="date" class="input-data" v-model="datafim"/>                        
                </div>
            </div>
            <br/>
            <div class="div-linha">
                <botao type="button" font_awesome_class="" 
                    label="Continuar" @click.native="mapaproducao"/>
            </div>      
        </div>		
	</div>

</template>


<script>

import moment from 'moment';
import TopBar from '@/components/layout/TopBar.vue';
import Botao from '@/components/shared/Botao.vue';

export default {
    name : 'MapaProducaoSelecionaPeriodo',
    components : {TopBar, Botao},
    data(){
        return {
            datainicio :  moment(new Date()).format('YYYY-MM-DD'),
            datafim: moment(new Date()).format('YYYY-MM-DD')
        }
    },

    methods : {
        mapaproducao: function(){

            var strData1 = moment(this.datainicio).format('DD/MM/YYYY');
            var strData2 = moment(this.datafim).format('DD/MM/YYYY');

            this.$router.push(`/mapaproducao/${encodeURIComponent(strData1)}/${encodeURIComponent(strData2)}/1`);

        },
        navigate: function(){
            this.$router.push(`/financeiro/mapaproducao`);
        }

        

    }
}
</script>

<style scoped>
    .label{
        width: 30%;
        float: left;
        line-height: 44px;
        margin: 10px 0px;
    }

    .campo{
        width: 70%;
        float: left;
    }


	.input-data:focus, .botao-pesquisa:focus{
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);	
		transition: all  0.2s ease-in-out;
		outline: none;
		border: 1px solid #428bca;
	}
	
	.input-data{
		font-size: 18px;
		border-radius: 10px 0 0 10px;
		border: 1px solid #dedede;
		
		padding: 10px;
		width: calc(100% - 22px);	
		transition: all  0.2s ease-in-out;	
        height: 26px;	
        margin: 10px 0px;
        width: 200px;

        font-family: Roboto, serif;
	
	}
    
    .div-principal{
        margin: 20px 10px;
        display:  table;
        width: calc(100% - 20px);
    }

    .div-linha{
        float: none;
        display:  table;
        width: 100%;
    }
</style>